module.exports = __webpack_public_path__ + "img/User_input_to_Mic.0d1f85f2.gif";